/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_soldil_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculate how to dilute a stock solution using C1V1 = C2V2.`)
};

const es_soldil_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcula cómo diluir una solución madre usando C1V1 = C2V2.`)
};

const de_soldil_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Berechnen Sie, wie eine Stammlösung mit C1V1 = C2V2 verdünnt wird.`)
};

const nl_soldil_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bereken hoe je een stockoplossing verdunt met C1V1 = C2V2.`)
};

const fr_soldil_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculez comment diluer une solution mère avec C1V1 = C2V2.`)
};

const it_soldil_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcola come diluire una soluzione madre usando C1V1 = C2V2.`)
};

const pt_br2_soldil_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcule como diluir uma solução estoque usando C1V1 = C2V2.`)
};

const pt_soldil_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcule como diluir uma solução-mãe usando C1V1 = C2V2.`)
};

const ja_soldil_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`C1V1 = C2V2 を使ってストック溶液の希釈方法を計算します。`)
};

const zh_soldil_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`使用 C1V1 = C2V2 计算如何稀释母液。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const soldil_tool_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.soldil_tool_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("soldil_tool_description", locale)
	if (locale === "en") return en_soldil_tool_description(inputs)
	if (locale === "es") return es_soldil_tool_description(inputs)
	if (locale === "de") return de_soldil_tool_description(inputs)
	if (locale === "nl") return nl_soldil_tool_description(inputs)
	if (locale === "fr") return fr_soldil_tool_description(inputs)
	if (locale === "it") return it_soldil_tool_description(inputs)
	if (locale === "pt-BR") return pt_br2_soldil_tool_description(inputs)
	if (locale === "pt") return pt_soldil_tool_description(inputs)
	if (locale === "ja") return ja_soldil_tool_description(inputs)
	return zh_soldil_tool_description(inputs)
};